
// @ts-nocheck
import { defineComponent} from 'vue'
import rem from '@/utils/rem.js'

rem(750, 750)

export default defineComponent({
  name: 'ServiceNoList',
  setup() {

  }
})
